export default __webpack_public_path__ + "static/media/download-blue.17c1fa54.svg";